/**
 * GalleryProvenance — one line saying where a gallery photo came from (addendum F-3): the
 * date, the visit's S-number linked to its ticket, the source and who added it. Never the
 * Drive description (see provenanceOf).
 */
import { Link } from 'react-router-dom';
import { provenanceOf } from '../../../lib/fieldService/galleryRows';
import type { GeneratorPhoto } from '../../../types/fieldService/generatorPhotos';

interface GalleryProvenanceProps {
  photo: GeneratorPhoto;
  /** `dark` for the lightbox's black backdrop. */
  tone?: 'light' | 'dark';
}

export function GalleryProvenance({ photo, tone = 'light' }: GalleryProvenanceProps) {
  const p = provenanceOf(photo);
  const muted = tone === 'dark' ? 'text-white/70' : 'text-slate-500';
  const link = tone === 'dark' ? 'text-white underline' : 'text-[#007ACC] hover:underline';
  return (
    <p className={`text-xs ${muted} flex flex-wrap items-center gap-x-2 gap-y-0.5`}>
      {p.date && <span>{p.date}</span>}
      {p.serviceId && (
        <Link to={`/field-service/tickets/${encodeURIComponent(p.serviceId)}`} className={`font-medium ${link}`}>
          {p.serviceId}
        </Link>
      )}
      <span>{p.source}</span>
      {p.addedBy && <span>Added by {p.addedBy}</span>}
    </p>
  );
}
